export const categories = [
  {
    slug: 'yingshi',
    name: '影视星闻',
    desc: '新剧动态、番位之争与片场幕后，追影视圈每一颗瓜。',
    icon: 'ri-film-line',
    tint: 'bg-primary-50 text-primary-700',
  },
  {
    slug: 'yinyue',
    name: '音乐现场',
    desc: '演唱会、舞台事故与音乐人的争议时刻。',
    icon: 'ri-mic-2-line',
    tint: 'bg-accent-100 text-accent-800',
  },
  {
    slug: 'zongyi',
    name: '综艺观察',
    desc: '真人秀名场面、导师对话与剪辑争议全解读。',
    icon: 'ri-tv-2-line',
    tint: 'bg-secondary-100 text-secondary-800',
  },
  {
    slug: 'quannei',
    name: '圈内动态',
    desc: '经纪合约、品牌代言与行业秘辛，吃遍圈内瓜田。',
    icon: 'ri-fire-line',
    tint: 'bg-primary-100 text-primary-800',
  },
];